import angular from 'angular';
import constants from 'app/constants';
import { default as userService } from '../../../services/membership/ss.user.service';
import DashboardDirectiveController from './dashboard.directive.controller';
import dashboardDirective from './dashboard.directive';

const library = require('@safe-systems/ss-ui-components');

const {
  authorizationService,
  fullCalendar,
  highCharts,
  utilityService
} = library;

export default angular.module('app.components.global.dashboard', [
  constants,
  authorizationService,
  userService,
  fullCalendar,
  highCharts,
  utilityService,
])
  .directive('dashboard', dashboardDirective)
  .controller('DashboardDirectiveController', DashboardDirectiveController)
  .name;

console.log('app.components.global.dashboard created');
